const d3 = require('d3')

const moment = require('moment');

const parseDate = d3.utcParse('%Y-%m-%d');
const formatValue = d3.format('.2f');
const formatDate = d3.utcFormat('%B %-d, %Y');
const formatChange = () => {
  const f = d3.format('+.2%');
  return (y0, y1) => f((y1 - y0) / y0);
};
const capitalizeWords = (str) => {
  return str.split(' ').map(element => {
    return element.charAt(0).toUpperCase() + element.substring(1).toLowerCase();
  }).join(' ');
}

module.exports={
  parseDate,
  formatChange,
  formatValue,
  formatDate,
  capitalizeWords
}